import { Card as BaseCard, CardField, CardFooter, CardHeader, CardMain } from './card';

export const Card = Object.assign(BaseCard, {
  Field: CardField,
  Footer: CardFooter,
  Header: CardHeader,
  Main: CardMain,
});
